import {
  FloorPlanEditorDeviceMarkerActions,
  FloorPlanEditorDeviceMarkerActionTypes
} from '../actions/floor-plan-editor-device-marker.actions';
import {DeviceMarker, DeviceMarkerActionResponse, SetInitialDeviceMarkersResponse} from '../../floor-plan-shared/models/device-marker';
import {RemoveAllDeviceMarkerSuccessPayload} from '../models/floor-plan-editor-device-marker';

export interface State {
  entities: { [deviceUuid: string]: DeviceMarker };
  initialEntities: { [deviceUuid: string]: DeviceMarker };
  addedDeviceUuids: string[];
  updatedDeviceUuid: string;
  removedDeviceUuids: string[];
  didEntitiesChange: boolean;
  isRemoveAllInvoked: boolean;
  isInitialized: boolean;
}

export const initialState: State = {
  entities: {},
  initialEntities: {},
  addedDeviceUuids: null,
  updatedDeviceUuid: null,
  removedDeviceUuids: null,
  didEntitiesChange: false,
  isRemoveAllInvoked: false,
  isInitialized: false
};

export function reducer(state = initialState, action: FloorPlanEditorDeviceMarkerActions): State {
  switch (action.type) {

    case FloorPlanEditorDeviceMarkerActionTypes.SetInitialDeviceMarkersSuccess: {
      const setInitialDeviceMarkersResponse: SetInitialDeviceMarkersResponse = action.payload;
      return {
        ...state,
        entities: setInitialDeviceMarkersResponse.entities,
        initialEntities: setInitialDeviceMarkersResponse.entities,
        addedDeviceUuids: setInitialDeviceMarkersResponse.deviceUuids,
        updatedDeviceUuid: null,
        removedDeviceUuids: null,
        didEntitiesChange: false,
        isInitialized: true
      };
    }

    case FloorPlanEditorDeviceMarkerActionTypes.AddDeviceMarkerSuccess: {
      const deviceMarkerActionResponse: DeviceMarkerActionResponse = action.payload;
      return {
        ...state,
        entities: deviceMarkerActionResponse.entities,
        addedDeviceUuids: [deviceMarkerActionResponse.deviceUuid],
        didEntitiesChange: deviceMarkerActionResponse.didEntitiesChange,
        updatedDeviceUuid: null,
        removedDeviceUuids: null,
        isRemoveAllInvoked: false
      };
    }

    case FloorPlanEditorDeviceMarkerActionTypes.UpdateDeviceMarkerSuccess: {
      const deviceMarkerActionResponse: DeviceMarkerActionResponse = action.payload;
      return {
        ...state,
        entities: deviceMarkerActionResponse.entities,
        updatedDeviceUuid: deviceMarkerActionResponse.deviceUuid,
        didEntitiesChange: deviceMarkerActionResponse.didEntitiesChange,
        addedDeviceUuids: null,
        removedDeviceUuids: null,
        isRemoveAllInvoked: false
      };
    }

    case FloorPlanEditorDeviceMarkerActionTypes.RemoveDeviceMarkerSuccess: {
      const deviceMarkerActionResponse: DeviceMarkerActionResponse = action.payload;
      return {
        ...state,
        entities: deviceMarkerActionResponse.entities,
        removedDeviceUuids: [deviceMarkerActionResponse.deviceUuid],
        didEntitiesChange: deviceMarkerActionResponse.didEntitiesChange,
        updatedDeviceUuid: null,
        addedDeviceUuids: null,
        isRemoveAllInvoked: false
      };
    }

    case FloorPlanEditorDeviceMarkerActionTypes.RemoveAllDeviceMarkerSuccess: {
      const removeAllDeviceMarkerSuccessPayload: RemoveAllDeviceMarkerSuccessPayload = action.payload;
      return {
        ...state,
        entities: {},
        initialEntities: {},
        didEntitiesChange: false,
        addedDeviceUuids: null,
        updatedDeviceUuid: null,
        removedDeviceUuids: removeAllDeviceMarkerSuccessPayload.deviceMarkerUuids,
        isRemoveAllInvoked: true,
        isInitialized: false
      };
    }

    case FloorPlanEditorDeviceMarkerActionTypes.ResetInitialEntitiesToCurrent: {
      return {
        ...state,
        initialEntities: {...state.entities},
        didEntitiesChange: false,
        addedDeviceUuids: null,
        updatedDeviceUuid: null,
        removedDeviceUuids: null,
        isRemoveAllInvoked: false
      };
    }

    default:
      return state;
  }
}

export const deviceMarkerEntities = (state: State) => state.entities;
export const initialDeviceMarkerEntities = (state: State) => state.initialEntities;
export const didDeviceMarkerEntitiesChange = (state: State) => state.didEntitiesChange;
export const addedDeviceMarkerUuids = (state: State) => state.addedDeviceUuids;
export const updatedDeviceMarkerUuid = (state: State) => state.updatedDeviceUuid;
export const removedDeviceMarkerUuids = (state: State) => state.removedDeviceUuids;
export const isRemoveAllDeviceMarkerInvoked = (state: State) => state.isRemoveAllInvoked;
export const isDeviceMarkerInitialized = (state: State) => state.isInitialized;
